import { getIsDataWorkerFaulted, getDataWorkerFault } from './isDataWorkerFaulted';

let fault: Error | undefined;
const callbacks: ((e: Error | undefined) => void)[] = [];

export function getOfflineDataFault(): Error | undefined {
    return fault || getDataWorkerFault();
}

export function getIsOfflineDataFaulted(): boolean {
    return !!fault || getIsDataWorkerFaulted();
}

export function setIsOfflineDataFaulted(e: Error | undefined): void {
    fault = e;
    for (const cb of callbacks) {
        cb(e);
    }
}

/**
 * Set a callback which will be called whenever the offline data fault changes.
 */
export function registerOfflineDataFaultCallback(cb: (e: Error | undefined) => void): void {
    callbacks.push(cb);
}
